import React, { useEffect, useState } from 'react';
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ProductService from '../services/Product';
import { Link } from 'react-router-dom'
import PrimaryGradientButton from '../component/PrimaryGradientButton';
import Loader from '../component/Loader';
import CartService from '../services/Cart'
import Carousel from 'react-bootstrap/Carousel';
import AlertMsg from '../component/AlertMsg';
import { Table } from 'react-bootstrap';
import DefaultImage from '../assets/images/productDefault.png'
import useScrollToTop from '../hooks/useScrollToTop';
const ProductDetailsPage = () => {
  useScrollToTop()
  const [isProductDetailsData, setIsProductDetailsData] = useState([])
  const [isProductDetailsAttribute, setIsProductDetailsAttribute] = useState([])
  const [isOverview, setIsOverview] = useState(true)
  const [isProductCategory, setIsProductCategory] = useState('')
  const [isSpecification, setIsSpecification] = useState(false)
  const [isImageSlider, setIsImageSlider] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
  const [showAlert, setShowAlert] = useState(false);
  const { product_id, category_id } = useParams();
  useEffect(() => {
    const ProductFetchData = async () => {
      try {
        const token = localStorage.getItem('access_token')

        const ProductFetchDataResponse = await ProductService.productDetailsWeb(token, product_id, category_id)
        if (!ProductFetchDataResponse.error) {

          setIsProductCategory(ProductFetchDataResponse.data[0].category_name)
          setIsProductDetailsData(ProductFetchDataResponse.data[0])
          setIsImageSlider(ProductFetchDataResponse.data[0].product_images)
          setIsProductDetailsAttribute(ProductFetchDataResponse.data[0].product_attributes)
          setLoading(false)
        }

      }
      catch (error) {
        console.error("Product Details")

      }
    }
    ProductFetchData()
  }, [])
  const handleTabClick = (tabName) => {
    setIsOverview(tabName === 'overview');
    setIsSpecification(tabName === 'specification');
  }
  //Add To Cart
  const handleAddCart = async (product_id, catalog_id) => {
    const token = localStorage.getItem('access_token');
    const payload = {
      product_id: product_id + '',
      quantity: '1',
      ip: '',
      catalog_id: catalog_id + '',
    };
    const res = await CartService.addToCart(payload, token);
    if (!res.error) {
      setShowAlert(true)
      setIsLoginSuccess({ isLogin: true, text: res.data.message })
      setTimeout(() => { setShowAlert(false) }, 3000)
    }

  }

  return (
    <>
      {loading && <Loader />}
      <BreadCrumbSecttion 
                pageTitle={isProductDetailsData?.product_name}
                parentPageOfCurrentPage="Rewards Category List"
                secondParentPageName ={isProductCategory}
                currentPageName={isProductDetailsData?.product_name}
                breadCrumbPathName='/rewards-category-list'
                secondParentPagePath={`/rewards-category-list/${category_id}`}/>
        
      <section className='padTop50 prpadBot100'>
        <Container>
          <Row>
            <Col xs={12} lg={4}>
              {isImageSlider.length > 0 &&
                <div className='productImageSlider'>

                  <Carousel>
                    {isImageSlider.map((item, index) => {
                      const imgSrc = item.product_image ? item.product_image : DefaultImage;
                      return (
                        <Carousel.Item key={index}>
                          <div className='productSliderImg'>
                            <img src={imgSrc} alt='image' className='img-fuid-hm-banner' />
                          </div>
                        </Carousel.Item>
                      );
                    })}
                  </Carousel>
                </div>
              }
              {isImageSlider.length <= 0 &&

                <div className='productSliderImg'>
                  <img src={DefaultImage} alt='image' className='img-fuid-hm-banner' />
                </div>

              }

            </Col>
            <Col xs={12} lg={8}>
              <Row>
                <Col xs={12} className='px-0'>
                  <div className='productDetailsTable'>
                    <div className="notificationTabList">
                      <ul>
                        <li className={isOverview ? 'active' : ''} onClick={() => handleTabClick('overview')}>
                          <Link>Overview</Link>
                        </li>
                        <li className={isSpecification ? 'active' : ''} onClick={() => handleTabClick('specification')}>
                          <Link>Specification</Link>
                        </li>
                      </ul>
                    </div>
                    {isOverview &&
                      <div className='productOverview '>
                        <Container>
                          <Row>
                            <Col>
                              <Table striped bordered>
                                <tbody>
                                  <tr>
                                    <td><strong>Product Name</strong></td>
                                    <td>{isProductDetailsData.product_name}</td>
                                  </tr>
                                  <tr>
                                    <td><strong>Short Description</strong></td>
                                    <td>{isProductDetailsData.short_desc}</td>
                                  </tr>
                                  <tr>
                                    <td><strong>Long Description</strong></td>
                                    <td>{isProductDetailsData.long_desc}</td>
                                  </tr>
                                </tbody>
                              </Table>
                            </Col>
                          </Row>

                        </Container>

                      </div>

                    }
                    {isSpecification &&
                      <div className='specificationView'>
                        <Container>
                          <Row>
                            <Col>
                              <Table striped bordered hover>
                                <tbody>
                                  {
                                    isProductDetailsAttribute.map((item, index) => {
                                      const { attribute_key, attribute_value } = item
                                      return (
                                        <tr key={index}>
                                          <td><b>{attribute_key}</b></td>
                                          <td>{attribute_value}</td>
                                        </tr>

                                      )
                                    })
                                  }
                                </tbody>
                              </Table>
                            </Col>
                          </Row>

                        </Container>
                      </div>
                    }
                  </div>
                </Col>
                <Col xs={12} md={3} className='mt-2'>
                  <PrimaryGradientButton buttonText="Add To Cart" onClick={() => handleAddCart(isProductDetailsData.product_id, isProductDetailsData.catalog_id)} />
                </Col>
                <Col xs={12}>
                  <div className='productListAlert alertBoxWrap'>
                    {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                      heading={isLoginSuccess.heading}
                      text={isLoginSuccess.text} />
                    }

                  </div>
                </Col>
              </Row>

            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ProductDetailsPage;
